import { type Accessor, createSignal, type Setter } from "solid-js";

export function PageIndicator(props: { currentPage: Accessor<number>; setPage: Setter<number>; totalPages: Accessor<number> }) {
	const [isEditing, setIsEditing] = createSignal(false);

	return (
		<>
			<button class="button" type="button" disabled={props.currentPage() === 0} onClick={() => props.setPage((p) => p - 1)}>
				&lt; Prev
			</button>
			<input
				class="num-input"
				inputMode="numeric"
				aria-label="Page number"
				value={isEditing() ? props.currentPage() + 1 : `${props.totalPages() === 0 ? 0 : props.currentPage() + 1} / ${props.totalPages()}`}
				onFocus={() => {
					setIsEditing(true);
				}}
				onBlur={() => {
					setIsEditing(false);
				}}
				onInput={(e) => {
					const v = Number(e.currentTarget.value) - 1;
					if (!Number.isNaN(v) && Number.isInteger(v) && 0 <= v && v < props.totalPages()) {
						props.setPage(Math.min(Math.max(0, v), props.totalPages() - 1));
					}
				}}
			/>
			<button
				class="button"
				type="button"
				disabled={props.currentPage() >= props.totalPages() - 1}
				onClick={() => props.setPage((p) => p + 1)}
			>
				Next &gt;
			</button>
		</>
	);
}
